<!--
@Author: Calvin Green <calvin>
@Date:   2022-03-19T15:13:45+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-08-29T09:49:30+02:00
@Copyright: Diversitude 2022
-->



<template>
    <div v-if="ready">
        <div v-show="locations.length == 0">
            <div style="text-align: center; font-size: 25px;">
                <span>Please add a facility location!</span>
            </div>
        </div>
        <div  v-show="locations.length > 0">
            <webix-ui :config="config" v-model="locations"></webix-ui>
            <div id="locationPaging"></div>
        </div>
    </div>
</template>

<script>
import { facilityAdminMethods, facilityAdminState } from '@/state/helpers'
import _ from 'lodash'
import Swal from "sweetalert2";
/*eslint-disable no-undef*/
function renderFoliaName(obj) {
    var el = window.inst;
    if (el && obj.folia_link_id != null && obj.folia_link_id > -1) {
        var findIndex = _.findIndex(el.foliaLocations, function(o) { return o.id == obj.folia_link_id; });
        if (findIndex > -1) {
            return el.foliaLocations[findIndex].name;
        }
    }
    return "Not Set";
}
/*eslint-enable no-undef*/

export default {
    data:() => ({
        clickedAction: false,
        ready: false,
        config:{
            id: 'locationsTable',
            view: 'datatable',
            css: "datatableUsers webix_header_border webix_data_border",
            autoheight: true,
            //hover: "datatableHover",
            minHeight:50,
            minColumnWidth: 120,
            scrollY:false,
            scrollX:true,
            resizeColumn: true,
            select: false,
            pager:{
                template:"{common.prev()} {common.pages()} {common.next()}",
                container:"locationPaging",
                size:15,
                group:5
            },
            columns:[
                { id: 'name', header:["Location Name", {content: "textFilter"}], width: 250},
                { id: 'type_name', header:["Location Type", {content: "selectFilter"}], width: 250},
                { id: 'sqm', header:'Size', width: 150},
                { id: 'folia_location', header:'Linked Folia Cultivation Location', width: 250,  template: function(obj){
                    return renderFoliaName(obj);
                }},
                { id: 'actions', header:'Actions', fillspace: 0.2,  template: function(){
                    return `<div class="tableIcons"><i title="Delete Location" class="webix_icon_hover webix_icon deleteAction fas fa-trash"></i></div>`;
                }}
            ],
            on:{//eslint-disable-next-line
                onItemClick(id, e, node){
                    var el = this.$scope.$parent;
                    setTimeout(()=>{
                        if(el.clickedAction == false){
                            el.$eventHub.$emit('editLocation', id.row);
                        }
                    }, 50)

                }
            },
            onClick:{
                //eslint-disable-next-line
                edit_icon(event, cell, target){
                    var el = this.$scope.$parent;
                    el.clickedAction = true;
                    setTimeout(()=> {el.clickedAction = false;} , 150)
                    /*alert('Edit')*/
                },
                //eslint-disable-next-line
                deleteAction: function(id, e, trg) {
                    var el = this.$scope.$parent;
                    var item = this.getItem(e.row);
                    Swal.fire({
                      title: "Are you sure you want to delete " + item.name + "?",
                      text: "You won't be able to revert this!",
                      icon: "warning",
                      showCancelButton: true,
                      confirmButtonColor: "#34c38f",
                      cancelButtonColor: "#f46a6a",
                      confirmButtonText: "Yes, delete it!"
                    }).then(result => {
                      if (result.value) {
                          el.deleteClientLocation({location_id: e.row}).then(()=>{
                              el.$emit('reloadLocations');
                          });
                      }
                  });
                }

            }
        },
    }),
    props: {
        foliaLocations: {
            default:function(){
                return [];
            }
        }
    },
    computed:{
        ...facilityAdminState,
        locations(){
            return this.client_locations;
        },

    },
    methods:{
        ...facilityAdminMethods,
    },
    mounted(){
        window.inst = this;
        setTimeout(()=>{
            window.inst.ready = true;
        }, 150)
    },
    beforeDestroy() {
        window.inst = undefined;
    }
}
</script>

<style>

</style>
